import { View } from 'react-native';
import { Icon } from '@photosi/rn-components/icon/Icon';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { SELECTED_MENU_ITEMS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { styles } from './PickerSourceIcon.styles';
export const PickerSourceIcon = ({
  type,
  color,
  filled,
}: {
  type: SELECTED_MENU_ITEMS;
  color: string;
  filled?: boolean;
}) => {
  switch (type) {
    case SELECTED_MENU_ITEMS.Computer:
      return (
        <View style={styles.menuIcon}>
          <Icon name={ICON_NAMES.Pc} color={color} />
        </View>
      );
    case SELECTED_MENU_ITEMS.GooglePhoto:
      return (
        <View style={styles.menuIcon}>
          <Icon name={ICON_NAMES.GooglePhoto} />
        </View>
      );
    case SELECTED_MENU_ITEMS.Gallery:
      return (
        <View style={styles.menuIcon}>
          <Icon name={ICON_NAMES.PhotoAlbum} filled={filled} color={color} />
        </View>
      );
    case SELECTED_MENU_ITEMS.Smartphone:
      return (
        <View style={styles.menuIcon}>
          <Icon name={ICON_NAMES.Smartphone2} color={color} />
        </View>
      );
    case SELECTED_MENU_ITEMS.FamilyFriends:
      return (
        <View style={styles.menuIcon}>
          <Icon name={ICON_NAMES.People2} color={color} />
        </View>
      );
    case SELECTED_MENU_ITEMS.Add:
      return (
        <View style={styles.menuIconAdd}>
          <Icon name={ICON_NAMES.Plus} filled={filled} color={color} />
        </View>
      );
  }
};
